import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Header from "./header";
import logo from "../assets/pss-code-tool-logo-transparent.png";

const chevronRight = <FontAwesomeIcon icon={faChevronRight} />;

function Welcome(props) {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="welcome">
          <img
            className="animate__animated animate__pulse logo"
            src={logo}
            alt="PSS Code Tool Logo"
          />
          <h1 className="animate__animated animate__fadeIn">{props.title}</h1>
          <p className="animate__animated animate__fadeIn description">
            {props.subtitle}
          </p>
          <Link to="/guide">
            <button className="animate__animated animate__bounceInUp btn">
              Let's Go!{chevronRight}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
